module.exports = __webpack_public_path__ + "img/4ne.e4bc81cb.svg";